import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';



import {environment} from '../../environments/environment';

import {User} from '../_models/user';
import {Tokens} from '../_models/tokens';

@Injectable({
  providedIn: 'root'
})
export class AuthenicationService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  private loggedUser: string;
  private baseUrl: string = environment.apiUrl;
  public userdetaild: string;
  redirectUrl: string;


  constructor(private http: HttpClient,private router: Router) {
    // @ts-ignore
    this.currentUserSubject = new BehaviorSubject<User>(localStorage.getItem(this.JWT_TOKEN));
  }

  public get currentUserValue(): User {
    if (this.currentUserSubject != null) {
      return this.currentUserSubject.value;
    } else {
      return null;
    }
  }


  login(user): Observable<boolean> {
    return this.http.post<any>(`${this.baseUrl}/user/authuser`, user)
      .pipe(
        tap(tokens => this.doLoginUser(user.Users_email, tokens)),
        map(token => {
        return token;
      }));
  }

  logout() {
    this.doLogoutUser();
    this.currentUserSubject = null;
  }

  isLoggedIn() {
    return !!this.getJwtToken();
  }

  refreshToken() {
    return this.http.post<any>(`${this.baseUrl}/user/sliderdata`, {
      refresh_token: this.getRefreshToken()
    }).pipe(tap((tokens: Tokens) => {
      if (tokens.ResponseCode == '200') {
          this.storeJwtToken(tokens.jwt);
      }else{
        this.logout();
        location.reload();
      }
    }));
  }


  getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }

  private doLoginUser(username: string, tokens: Tokens) {
    this.loggedUser = username;
    // this.setDetails(tokens);
    this.storeTokens(tokens);
    // this.router.navigate(['/']);
  }

  private doLogoutUser() {
    this.loggedUser = null;
    this.removeTokens();
  }

  private getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeJwtToken(jwt: string) {
    localStorage.setItem(this.JWT_TOKEN, jwt);
  }

  private storeTokens(tokens: Tokens) {
    localStorage.setItem(this.JWT_TOKEN, tokens.jwt);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.refreshToken);
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
    localStorage.removeItem('userDetails');
  }

  logoutUser() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
    localStorage.removeItem('userDetails');
    this.currentUserSubject = null;
    location.reload();
  }


  validateToken(refreshToken): Observable<boolean> {
    return this.http.post<any>(`${this.baseUrl}/user/verifytoken`, refreshToken)
      .pipe(
        map(data => {
          return data;
        }));
  }


   userDetails() {
     try {
       const userdata = localStorage.getItem('userDetails');
      // console.log(JSON.parse(atob(userdata)));
       if (userdata) {
         return this.userdetaild = JSON.parse(atob(userdata));
       }else{
         this.logout();
       }
     }
     catch (err) {
       this.logout();
     }

  }


}
